import { ResetPasswordForm } from '@components/auth'

export const ResetPasswordPage = () => {
  return <ResetPasswordForm />
}
